// -   测试环境：https://testirweb-osl.comein.cn
// -   生产环境：https://irweb-osl.comein.cn
// 通过域名判断是否为生产环境：irweb-osl.comein.cn 为 true，否则为 false
const buildHostnames = ['47.237.174.64', 'irweb-osl.comein.cn', 'osl.irwebsite.comein.cn', 'group.osl.com'];
export const isBuild = buildHostnames.includes(window.location.hostname);

export const isAndroid = /Android/i.test(navigator.userAgent.toLowerCase());
export const isIOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent.toLowerCase());
export const isMobile = isAndroid || isIOS;

function isMacEnv() {
	const ua = navigator.userAgent || '';
	const platform = navigator.platform || '';
	return /Mac/.test(platform) || /Mac OS/.test(ua);
}
export const isMac = isMacEnv();

export const RESIZE_DEBOUNCE_TIME = 50;
